var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenueReverse(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7539 7.05768H18.4461V4.94232H16.7539V7.05768ZM16.7539 12.5577H18.4461V10.4423H16.7539V12.5577ZM16.7539 18.0577H18.4461V15.9423H16.7539V18.0577ZM15.4 22.5V21.125H20.9V1.875H10.3231V4.88412L9.22309 3.89518V0.5H22V22.5H15.4ZM0 22.5V10.8125L6.6 4.94228L13.2 10.8125V22.5H7.99615V16.3125H5.20385V22.5H0ZM1.1 21.125H4.10385V14.9375H9.09615V21.125H12.1V11.5L6.6 6.67162L1.1 11.5V21.125Z",
    fill: "#FE4747"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenueReverse);
export default __webpack_public_path__ + "static/media/venue-reverse.5248d2b83ba07846fdaa9063dd4c58cf.svg";
export { ForwardRef as ReactComponent };